export { default as SplashLayoutRoute } from './splash-layout';
